import { HttpInterceptorFn } from '@angular/common/http';
import { REQUIRE_AUTH } from './auth-context';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(REQUIRE_AUTH)) return next(req);

  const authData = localStorage.getItem('auth_data');

  if (!authData) return next(req);
  const token = JSON.parse(authData)?.token;

  const authReq = req.clone({
    setHeaders: { Authorization: `Bearer ${token}` },
  });
  return next(authReq);
};
